class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
    this.hoverCloseTimers = new Map();
    this.querySelectorAll('details').forEach((details) => {
      details.addEventListener('pointerenter', (event) => {
        if (!this.supportsHover(event)) return;
        clearTimeout(this.hoverCloseTimers.get(details));
        this.hoverCloseTimers.delete(details);

        this.closest('.header__inline-menu')?.querySelectorAll('header-menu').forEach((menu) => {
          if (menu !== this && !menu.contains(document.activeElement)) menu.close();
        });
        this.querySelectorAll('details').forEach((sibling) => {
          if (
            sibling !== details &&
            sibling.parentElement.parentElement === details.parentElement.parentElement &&
            !sibling.contains(document.activeElement)
          ) {
            this.closeDetails(sibling);
          }
        });

        details.open = true;
        details.querySelector('summary').setAttribute('aria-expanded', 'true');
      });

      details.addEventListener('pointerleave', (event) => {
        if (!this.supportsHover(event)) return;
        clearTimeout(this.hoverCloseTimers.get(details));
        this.hoverCloseTimers.set(
          details,
          setTimeout(() => {
            this.hoverCloseTimers.delete(details);
            if (!this.isConnected || details.matches(':hover') || details.contains(document.activeElement)) return;
            this.closeDetails(details);
          }, 180)
        );
      });
    });
  }

  supportsHover(event) {
    return (
      event.pointerType === 'mouse' &&
      window.matchMedia('(min-width: 990px) and (hover: hover) and (pointer: fine)').matches
    );
  }

  closeDetails(details) {
    details.querySelectorAll('details[open]').forEach((child) => {
      child.removeAttribute('open');
      child.querySelector('summary').setAttribute('aria-expanded', 'false');
    });
    details.removeAttribute('open');
    details.querySelector('summary').setAttribute('aria-expanded', 'false');
  }

  close() {
    this.hoverCloseTimers.forEach((timer) => clearTimeout(timer));
    this.hoverCloseTimers.clear();
    this.closeDetails(this.mainDetailsToggle);
  }

  disconnectedCallback() {
    this.close();
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }
}

customElements.define('header-menu', HeaderMenu);
